// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../css-loader/dist/cjs.js!../../../../../perfect-scrollbar/css/perfect-scrollbar.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2017, 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

::-webkit-scrollbar {
  height: var(--theia-scrollbar-width);
  width: var(--theia-scrollbar-width);
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--theia-scrollbarSlider-background);
}

::-webkit-scrollbar:hover {
  background: transparent;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--theia-scrollbarSlider-hoverBackground);
}

::-webkit-scrollbar-thumb:active {
  background: var(--theia-scrollbarSlider-activeBackground);
}

::-webkit-scrollbar-corner {
  background: transparent;
}

/*-----------------------------------------------------------------------------
| Perfect scrollbar
|----------------------------------------------------------------------------*/

#theia-app-shell .ps__rail-x,
#theia-dialog-shell .ps__rail-x,
#theia-breadcrumbs-popups-overlay .ps__rail-x {
  height: var(--theia-scrollbar-rail-width);
}

#theia-app-shell .ps__rail-x > .ps__thumb-x,
#theia-dialog-shell .ps__rail-x > .ps__thumb-x,
#theia-breadcrumbs-popups-overlay .ps__thumb-x {
  height: var(--theia-scrollbar-width);
  bottom: calc(
    (var(--theia-scrollbar-rail-width) - var(--theia-scrollbar-width)) / 2
  );
  background: var(--theia-scrollbarSlider-background);
  border-radius: 0px;
}

#theia-app-shell .ps__rail-x:hover,
#theia-app-shell .ps__rail-x:focus,
#theia-dialog-shell .ps__rail-x:hover,
#theia-dialog-shell .ps__rail-x:focus,
#theia-breadcrumbs-popups-overlay .ps__rail-x:hover,
#theia-breadcrumbs-popups-overlay .ps__rail-x:focus {
  height: var(--theia-scrollbar-rail-width);
}

#theia-app-shell .ps__rail-x:hover > .ps__thumb-x,
#theia-app-shell .ps__rail-x:focus > .ps__thumb-x,
#theia-app-shell .ps__rail-x.ps--clicking .ps__thumb-x,
#theia-dialog-shell .ps__rail-x:hover > .ps__thumb-x,
#theia-dialog-shell .ps__rail-x:focus > .ps__thumb-x,
#theia-dialog-shell .ps__rail-x.ps--clicking .ps__thumb-x,
#theia-breadcrumbs-popups-overlay .ps__rail-x:hover > .ps__thumb-x,
#theia-breadcrumbs-popups-overlay .ps__rail-x:focus > .ps__thumb-x,
#theia-breadcrumbs-popups-overlay .ps__rail-x.ps--clicking .ps__thumb-x {
  height: var(--theia-scrollbar-width);
}

#theia-app-shell .ps__rail-y,
#theia-dialog-shell .ps__rail-y,
#theia-breadcrumbs-popups-overlay .ps__rail-y {
  width: var(--theia-scrollbar-rail-width);
}

#theia-app-shell .ps__rail-y > .ps__thumb-y,
#theia-dialog-shell .ps__rail-y > .ps__thumb-y,
#theia-breadcrumbs-popups-overlay .ps__rail-y > .ps__thumb-y {
  width: var(--theia-scrollbar-width);
  right: calc(
    (var(--theia-scrollbar-rail-width) - var(--theia-scrollbar-width)) / 2
  );
  background: var(--theia-scrollbarSlider-background);
  border-radius: 0px;
}

#theia-app-shell .ps__rail-y:hover,
#theia-app-shell .ps__rail-y:focus,
#theia-dialog-shell .ps__rail-y:hover,
#theia-dialog-shell .ps__rail-y:focus,
#theia-breadcrumbs-popups-overlay .ps__rail-y:hover,
#theia-breadcrumbs-popups-overlay .ps__rail-y:focus {
  width: var(--theia-scrollbar-rail-width);
}

#theia-app-shell .ps__rail-y:hover > .ps__thumb-y,
#theia-app-shell .ps__rail-y:focus > .ps__thumb-y,
#theia-app-shell .ps__rail-y.ps--clicking .ps__thumb-y,
#theia-dialog-shell .ps__rail-y:hover > .ps__thumb-y,
#theia-dialog-shell .ps__rail-y:focus > .ps__thumb-y,
#theia-dialog-shell .ps__rail-y.ps--clicking .ps__thumb-y,
#theia-breadcrumbs-popups-overlay .ps__rail-y:hover > .ps__thumb-y,
#theia-breadcrumbs-popups-overlay .ps__rail-y:focus > .ps__thumb-y,
#theia-breadcrumbs-popups-overlay .ps__rail-y.ps--clicking .ps__thumb-y {
  right: calc(
    (var(--theia-scrollbar-rail-width) - var(--theia-scrollbar-width)) / 2
  );
  width: var(--theia-scrollbar-width);
}

#theia-app-shell .ps [class^="ps__rail"].ps--clicking > [class^="ps__thumb"],
#theia-dialog-shell .ps [class^="ps__rail"].ps--clicking > [class^="ps__thumb"],
#theia-breadcrumbs-popups-overlay
  .ps
  [class^="ps__rail"].ps--clicking
  > [class^="ps__thumb"] {
  background-color: var(--theia-scrollbarSlider-activeBackground);
}

#theia-app-shell .ps [class^="ps__rail"] > [class^="ps__thumb"]:hover,
#theia-app-shell .ps [class^="ps__rail"] > [class^="ps__thumb"]:focus,
#theia-dialog-shell .ps [class^="ps__rail"] > [class^="ps__thumb"]:hover,
#theia-dialog-shell .ps [class^="ps__rail"] > [class^="ps__thumb"]:focus,
#theia-breadcrumbs-popups-overlay
  .ps
  [class^="ps__rail"]
  > [class^="ps__thumb"]:hover,
#theia-breadcrumbs-popups-overlay
  .ps
  [class^="ps__rail"]
  > [class^="ps__thumb"]:focus {
  background: var(--theia-scrollbarSlider-hoverBackground);
}

#theia-app-shell .ps [class^="ps__rail"] > [class^="ps__thumb"]:active,
#theia-dialog-shell .ps [class^="ps__rail"] > [class^="ps__thumb"]:active,
#theia-breadcrumbs-popups-overlay
  .ps
  [class^="ps__rail"]
  > [class^="ps__thumb"]:active {
  background: var(--theia-scrollbarSlider-activeBackground);
}

#theia-app-shell .ps:hover > [class^="ps__rail"],
#theia-app-shell .ps--focus > [class^="ps__rail"],
#theia-app-shell .ps--scrolling-y > [class^="ps__rail"],
#theia-dialog-shell .ps:hover > [class^="ps__rail"],
#theia-dialog-shell .ps--focus > [class^="ps__rail"],
#theia-dialog-shell .ps--scrolling-y > [class^="ps__rail"],
#theia-breadcrumbs-popups-overlay .ps:hover > [class^="ps__rail"],
#theia-breadcrumbs-popups-overlay .ps--focus > [class^="ps__rail"],
#theia-breadcrumbs-popups-overlay .ps--scrolling-y > [class^="ps__rail"] {
  opacity: 1;
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/scrollbars.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAIjF;EACE,oCAAoC;EACpC,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;8EAE8E;;AAE9E;;;EAGE,yCAAyC;AAC3C;;AAEA;;;EAGE,oCAAoC;EACpC;;GAEC;EACD,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;;;;;;EAME,yCAAyC;AAC3C;;AAEA;;;;;;;;;EASE,oCAAoC;AACtC;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;;EAGE,mCAAmC;EACnC;;GAEC;EACD,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;;;;;;EAME,wCAAwC;AAC1C;;AAEA;;;;;;;;;EASE;;GAEC;EACD,mCAAmC;AACrC;;AAEA;;;;;;EAME,+DAA+D;AACjE;;AAEA;;;;;;;;;;;;EAYE,wDAAwD;AAC1D;;AAEA;;;;;;EAME,yDAAyD;AAC3D;;AAEA;;;;;;;;;EASE,UAAU;EACV,uBAAuB;AACzB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2017, 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n@import url(\"~perfect-scrollbar/css/perfect-scrollbar.css\");\n\n::-webkit-scrollbar {\n  height: var(--theia-scrollbar-width);\n  width: var(--theia-scrollbar-width);\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--theia-scrollbarSlider-background);\n}\n\n::-webkit-scrollbar:hover {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--theia-scrollbarSlider-hoverBackground);\n}\n\n::-webkit-scrollbar-thumb:active {\n  background: var(--theia-scrollbarSlider-activeBackground);\n}\n\n::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n/*-----------------------------------------------------------------------------\n| Perfect scrollbar\n|----------------------------------------------------------------------------*/\n\n#theia-app-shell .ps__rail-x,\n#theia-dialog-shell .ps__rail-x,\n#theia-breadcrumbs-popups-overlay .ps__rail-x {\n  height: var(--theia-scrollbar-rail-width);\n}\n\n#theia-app-shell .ps__rail-x > .ps__thumb-x,\n#theia-dialog-shell .ps__rail-x > .ps__thumb-x,\n#theia-breadcrumbs-popups-overlay .ps__thumb-x {\n  height: var(--theia-scrollbar-width);\n  bottom: calc(\n    (var(--theia-scrollbar-rail-width) - var(--theia-scrollbar-width)) / 2\n  );\n  background: var(--theia-scrollbarSlider-background);\n  border-radius: 0px;\n}\n\n#theia-app-shell .ps__rail-x:hover,\n#theia-app-shell .ps__rail-x:focus,\n#theia-dialog-shell .ps__rail-x:hover,\n#theia-dialog-shell .ps__rail-x:focus,\n#theia-breadcrumbs-popups-overlay .ps__rail-x:hover,\n#theia-breadcrumbs-popups-overlay .ps__rail-x:focus {\n  height: var(--theia-scrollbar-rail-width);\n}\n\n#theia-app-shell .ps__rail-x:hover > .ps__thumb-x,\n#theia-app-shell .ps__rail-x:focus > .ps__thumb-x,\n#theia-app-shell .ps__rail-x.ps--clicking .ps__thumb-x,\n#theia-dialog-shell .ps__rail-x:hover > .ps__thumb-x,\n#theia-dialog-shell .ps__rail-x:focus > .ps__thumb-x,\n#theia-dialog-shell .ps__rail-x.ps--clicking .ps__thumb-x,\n#theia-breadcrumbs-popups-overlay .ps__rail-x:hover > .ps__thumb-x,\n#theia-breadcrumbs-popups-overlay .ps__rail-x:focus > .ps__thumb-x,\n#theia-breadcrumbs-popups-overlay .ps__rail-x.ps--clicking .ps__thumb-x {\n  height: var(--theia-scrollbar-width);\n}\n\n#theia-app-shell .ps__rail-y,\n#theia-dialog-shell .ps__rail-y,\n#theia-breadcrumbs-popups-overlay .ps__rail-y {\n  width: var(--theia-scrollbar-rail-width);\n}\n\n#theia-app-shell .ps__rail-y > .ps__thumb-y,\n#theia-dialog-shell .ps__rail-y > .ps__thumb-y,\n#theia-breadcrumbs-popups-overlay .ps__rail-y > .ps__thumb-y {\n  width: var(--theia-scrollbar-width);\n  right: calc(\n    (var(--theia-scrollbar-rail-width) - var(--theia-scrollbar-width)) / 2\n  );\n  background: var(--theia-scrollbarSlider-background);\n  border-radius: 0px;\n}\n\n#theia-app-shell .ps__rail-y:hover,\n#theia-app-shell .ps__rail-y:focus,\n#theia-dialog-shell .ps__rail-y:hover,\n#theia-dialog-shell .ps__rail-y:focus,\n#theia-breadcrumbs-popups-overlay .ps__rail-y:hover,\n#theia-breadcrumbs-popups-overlay .ps__rail-y:focus {\n  width: var(--theia-scrollbar-rail-width);\n}\n\n#theia-app-shell .ps__rail-y:hover > .ps__thumb-y,\n#theia-app-shell .ps__rail-y:focus > .ps__thumb-y,\n#theia-app-shell .ps__rail-y.ps--clicking .ps__thumb-y,\n#theia-dialog-shell .ps__rail-y:hover > .ps__thumb-y,\n#theia-dialog-shell .ps__rail-y:focus > .ps__thumb-y,\n#theia-dialog-shell .ps__rail-y.ps--clicking .ps__thumb-y,\n#theia-breadcrumbs-popups-overlay .ps__rail-y:hover > .ps__thumb-y,\n#theia-breadcrumbs-popups-overlay .ps__rail-y:focus > .ps__thumb-y,\n#theia-breadcrumbs-popups-overlay .ps__rail-y.ps--clicking .ps__thumb-y {\n  right: calc(\n    (var(--theia-scrollbar-rail-width) - var(--theia-scrollbar-width)) / 2\n  );\n  width: var(--theia-scrollbar-width);\n}\n\n#theia-app-shell .ps [class^=\"ps__rail\"].ps--clicking > [class^=\"ps__thumb\"],\n#theia-dialog-shell .ps [class^=\"ps__rail\"].ps--clicking > [class^=\"ps__thumb\"],\n#theia-breadcrumbs-popups-overlay\n  .ps\n  [class^=\"ps__rail\"].ps--clicking\n  > [class^=\"ps__thumb\"] {\n  background-color: var(--theia-scrollbarSlider-activeBackground);\n}\n\n#theia-app-shell .ps [class^=\"ps__rail\"] > [class^=\"ps__thumb\"]:hover,\n#theia-app-shell .ps [class^=\"ps__rail\"] > [class^=\"ps__thumb\"]:focus,\n#theia-dialog-shell .ps [class^=\"ps__rail\"] > [class^=\"ps__thumb\"]:hover,\n#theia-dialog-shell .ps [class^=\"ps__rail\"] > [class^=\"ps__thumb\"]:focus,\n#theia-breadcrumbs-popups-overlay\n  .ps\n  [class^=\"ps__rail\"]\n  > [class^=\"ps__thumb\"]:hover,\n#theia-breadcrumbs-popups-overlay\n  .ps\n  [class^=\"ps__rail\"]\n  > [class^=\"ps__thumb\"]:focus {\n  background: var(--theia-scrollbarSlider-hoverBackground);\n}\n\n#theia-app-shell .ps [class^=\"ps__rail\"] > [class^=\"ps__thumb\"]:active,\n#theia-dialog-shell .ps [class^=\"ps__rail\"] > [class^=\"ps__thumb\"]:active,\n#theia-breadcrumbs-popups-overlay\n  .ps\n  [class^=\"ps__rail\"]\n  > [class^=\"ps__thumb\"]:active {\n  background: var(--theia-scrollbarSlider-activeBackground);\n}\n\n#theia-app-shell .ps:hover > [class^=\"ps__rail\"],\n#theia-app-shell .ps--focus > [class^=\"ps__rail\"],\n#theia-app-shell .ps--scrolling-y > [class^=\"ps__rail\"],\n#theia-dialog-shell .ps:hover > [class^=\"ps__rail\"],\n#theia-dialog-shell .ps--focus > [class^=\"ps__rail\"],\n#theia-dialog-shell .ps--scrolling-y > [class^=\"ps__rail\"],\n#theia-breadcrumbs-popups-overlay .ps:hover > [class^=\"ps__rail\"],\n#theia-breadcrumbs-popups-overlay .ps--focus > [class^=\"ps__rail\"],\n#theia-breadcrumbs-popups-overlay .ps--scrolling-y > [class^=\"ps__rail\"] {\n  opacity: 1;\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
